<app-loader *ngIf="loaderIcon | async"></app-loader>
<form [formGroup]="layoutForm">
    <div id="ContainerMain" class="container-fluid">
        <div class="site_height">
            <div class="row my-2" formGroupName="layoutDiagramFilter">
                <div class="col-md-4 align-items-center d-flex legendDropDown">
                    <label style="width: 170px;" i18n>Category Legend</label> &nbsp; &nbsp;
                    <div class="custom-dropdown form-control" style="text-align: right;justify-content: end;"
                        (click)="toggleDropdown()">
                        <i class="fas fa-chevron-down" x></i>
                        <div *ngIf="isDropdownOpen" class="dropdown-list" (click)="stopPropagation($event)">
                            <div *ngFor="let category of categoryLegend" class="color-option"
                                (click)="closeCategoryLegend()">
                                <span class="color-text">{{ category.categoryName }}</span>
                                <span class="color-box" [style.background-color]="category.color"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-3 d-flex align-items-center" style="min-width: 250px;">
                    <label i18n>{{ 'Find Booth' | wordReplace }}</label>&nbsp;&nbsp;
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Search" formControlName="searchBooth"
                            (blur)="changeSearchText()">
                        <div class="input-group-append" (click)="searchNodes()">
                            <span class="input-group-text ms-2" style="padding-bottom: 10px; padding-top: 10px;">
                                <i class="fa fa-search text-white"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-md-3 d-flex align-items-center" style="min-width: 240px;">
                    <button class="btn-outline-primary zoom-btn mr-2" style="background-color: white" (click)="layoutZoomInClick($event)">
                        <img src="../assets/images/ZoomIn.svg" class="img-fluid" />
                    </button>
                    <button class="btn-outline-info zoom-btn mr-2" style="background-color: white" (click)="layoutZoomOutClick($event)">
                        <img src="../assets/images/ZoomOut.svg" class="img-fluid" />
                    </button>
                </div>

                <div class="col-md-2 d-flex align-items-center justify-content-end" style="min-width: 160px;">
                    <button type="button" class="btn btnAS me-1" (click)="AddSelectedBoothsToGrid()"
                        [disabled]="noboothSelected" i18n>
                        Done
                    </button>
                    <button type="button" class="btn btn-orange" (click)="closeLayoutForm()">Close</button>
                </div>
            </div>
            <div class="row my-2" formGroupName="layoutDiagramFilter">
                <div class="col-md-12 align-items-center" style="font-weight: bold;text-align: center;">
                    Part: {{selectedPartName}}
                </div>
            </div>
            <div class="row my-2" style="display: none;">
                <div class="col-md-3 align-items-center d-flex">
                    Booth#: {{BoothNumber}}
                </div>
                <div class="col-md-3 align-items-center d-flex">
                    Booth Type: {{BoothType}}
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mb-3">
                    <div class="layoutDiagramSection" id="diagram-container">
                        <ejs-diagram #diagram width="100%" style="overflow: visible;" [selectedItems]="selectedItems"
                            (click)="nodeClick($event)" [tooltip]="tooltip" [tool]="tool" [snapSettings]='snapSettings'
                            (created)='created($event)' (mouseover)="nodeMouseOver($event)"></ejs-diagram>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>